import { Charts } from './Charts';
import SchedulingChartsDataProvider from './contexts/SchedulingChartsDataContext';

const SchedulingWrapper = () => {
    return (
        <SchedulingChartsDataProvider>
            <Charts />
        </SchedulingChartsDataProvider>
    );
};

export default SchedulingWrapper;
